import { ICatalog } from '../../shared/types/catalog';
import { IMainCatalogItem } from '../../shared/types/main-catalog';

export const getProcesses = (catalogType: string, catalog: ICatalog) => {
  let processesData: IMainCatalogItem[] = [];

  if (catalogType === 'processes') {
    if (
      catalog &&
      Array.isArray(catalog?.process?.children) &&
      Array.isArray(catalog?.processes_relation)
    ) {
      processesData = [
        //@ts-ignore
        ...catalog?.process?.children,
        ...catalog?.processes_relation,
      ];
      return processesData;
    }
  } else {
    if (
      catalog &&
      Array.isArray(catalog?.processes_relation) &&
      Array.isArray(catalog?.processes_relation?.[0]?.children)
    ) {
      processesData = [
        catalog?.processes_relation[0],
        ...catalog?.processes_relation[0]?.children,
        ...catalog?.processes_relation?.filter(
          (process, index: number) => index !== 0
        ),
      ];
      return processesData;
    }
  }
};
